/**
 * Created by neo on 22.11.2023
 */
import { makeAutoObservable } from 'mobx';

export type RouteChallengeTeamReachedLocation = {
  locationId: string;
  dateTime: Date;
  requiredPoints: number;
  points: number;
  memberId: string;
};

export function createRouteChallengeTeamReachedLocation(json?: Partial<RouteChallengeTeamReachedLocation>): RouteChallengeTeamReachedLocation {
  return makeAutoObservable({
    locationId: json?.locationId ?? '',
    dateTime: json?.dateTime ? new Date(json.dateTime as any) : new Date(),
    requiredPoints: json?.requiredPoints ?? 0,
    points: json?.points ?? 0,
    memberId: json?.memberId ?? '',
  });
}
